import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import Title from './components/Title';
import {
  apiV2MobileRemoteGetConfigPost,
  apiV2MobileRemoteSendCommandPost,
  V2MobileRemoteGetConfigPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { message } from '@maxtropy/components';
import { Spin } from 'antd';
const IpConfiguration = () => {
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState<string | null>();
  const [pressedCard, setPressedCard] = useState<number | undefined>();
  const [buttonList, setButtonList] = useState<V2MobileRemoteGetConfigPostResponse['buttonConfigs']>();
  const [isLoading, setIsLoading] = useState(true);
  const handleCardClick = (buttonId: number | undefined) => {
    if (!ipAddress) return;
    setPressedCard(buttonId);
    setTimeout(() => {
      setPressedCard(undefined);
    }, 200);
    // 发送指令
    apiV2MobileRemoteSendCommandPost({ buttonId }).then(() => {
      message.success('指令发送成功');
    });
  };

  useEffect(() => {
    //获取配置信息
    apiV2MobileRemoteGetConfigPost({}).then(res => {
      setIpAddress(res.targetPcIp);
      setButtonList(res.buttonConfigs);
      setIsLoading(false);
    });
  }, []);
  return (
    <>
      <Spin spinning={isLoading}>
        <div className={styles.ipAddressContainer}>
          {ipAddress ? (
            <>
              <div className={styles.wifiIcon}></div>
              <div className={styles.ipText}>{ipAddress}</div>
            </>
          ) : (
            <>
              <div className={styles.noWifiIcon}></div>
              <div className={styles.noIpText}>未连接</div>
            </>
          )}
          <div className={styles.ButtonActive} onClick={() => navigate(`/ip/configuration/phone-config`)}>
            修改手机号
          </div>
          <div className={styles.ButtonActive} onClick={() => navigate(`/ip/configuration/button-config`)}>
            按钮配置
          </div>
        </div>
        <Title>功能菜单</Title>

        <div className={styles.mainContainer}>
          <div className={styles.cardContainer}>
            {buttonList?.map(item => (
              <div
                key={item.buttonId}
                className={`${styles.card} ${
                  !ipAddress ? styles.cardDisabled : pressedCard === item.buttonId ? styles.cardPressed : ''
                }`}
                onClick={() => handleCardClick(item.buttonId)}
              >
                <div className={styles.cardContent}>{item.buttonName}</div>
              </div>
            ))}
          </div>
        </div>
      </Spin>
    </>
  );
};

export default IpConfiguration;
